
<style scoped>
.file-input-container {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px; /* Reduce el margen para múltiples inputs */
    border: 1px solid #eee;
    padding: 10px;
    border-radius: 5px;
    background-color: #f9f9f9;
}

.file-input-label {
    display: inline-block;
    padding: 8px 15px;
    background-color: #6985f5;
    color: white !important;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    flex-shrink: 0;
}

.file-input-label:hover {
    background-color: #4467f2;
}

.hidden-file-input {
    display: none;
}

.selected-file-name {
    margin-left: 5px;
    font-weight: bold;
    color: #333;
    flex-grow: 1; /* Permite que el nombre ocupe espacio */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.no-file-selected {
    margin-left: 5px;
    color: #383838;
    font-style: italic;
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.clear-button {
    padding: 6px 12px;
    background-color: #dc3545 !important;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    flex-shrink: 0;
}

.clear-button:hover {
    background-color: #c82333;
}

.remove-button {
    padding: 6px 10px;
    background-color: #c82333;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    flex-shrink: 0;
}

.remove-button:hover {
  background-color: #5a6268;
}
</style>
<template>
    <div class="file-input-container">
        <label :for="`file-upload-${_uid}`" class="file-input-label">
            {{ labelText }}
            <span v-if="fileName" class="selected-file-name">{{ fileName }}</span>
            <span v-else class="no-file-selected">No file selected</span>
        </label>
        <input
            type="file"
            :id="`file-upload-${_uid}`" 
            ref="fileInput"
            @change="handleFileChange"
            :accept="acceptedTypes"
            class="hidden-file-input"
            :disabled="is_read || is_edit"
        />
        <button v-if="fileName" @click="clearFile" class="clear-button" :disabled="is_read" >
            Clear
        </button>
        <button @click="$emit('remove-input', fileData)" class="remove-button" :disabled="is_read" >X</button>
    </div>
</template>

<script>
export default {
    name: 'FileInput',
    props: {
        labelText: {
            type: String,
            default: 'Select File',
        },
        acceptedTypes: {
            type: String,
            default: '*',
        },
        initialFile: {
            type: [File, Object], 
            default: null,
        },
        fileData: { 
            type: Object,
            default: () => ({})
        },
        is_read : {
            type: Boolean,
            default : false,
        },
        is_edit : {
            type : Boolean,
            default : false
        }
    },
    data() {
        return {
            selectedFile: this.initialFile, 
            fileName: this.initialFile ? this.initialFile.name : '', // Inicializa el nombre
        };
    },
    watch: {
        initialFile: {
            immediate: true, 
            handler(newFile) {
                if (newFile) {
                if (newFile instanceof File) {
                    this.selectedFile = newFile;
                    this.fileName = newFile.name;
                } else if (newFile && typeof newFile.name === 'string') {
                    this.fileName = newFile.name;
                    this.selectedFile = null; 
                }
                } else {
                this.clearFile(); 
                }
            },
        },
    },
    methods: {
        handleFileChange(event) {
            const files = event.target.files;
            if (files.length > 0) {
                this.selectedFile = files[0];
                this.fileName = this.selectedFile.name;
                this.$emit('file-selected', { file: this.selectedFile, originalData: this.fileData }); 
            } else {
                this.clearFile();
            }
        },

        clearFile() {
             this.selectedFile = null;
            this.fileName = '';
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = ''; 
            }
            this.$emit('file-cleared', this.fileData);
        },
    },
};
</script>